<template>
  <header class="app-header text-right fixed-top" ref="app-header">
    <a href="/" class="app-header__volver">
      &laquo; Volver <span class="d-none d-sm-inline">a la portada</span>
    </a>
    <a href="/">
      <img  :src="iddiario == 12 ? require(`@/assets/image/${iddiario}.png`) : require(`@/assets/image/${iddiario}.svg`)" alt="" />
    </a>
  </header>
</template>

<script>
export default {
  props: {
    iddiario: {
      type: [String, Number],
      required: true
    }
  }

}
</script>